<div class="font-weight-selector">
  <div [ngClass]="{ bold: isBold }" class="pointer" (click)="click()">B</div>

  <!-- <div class="position-relative" *ngIf="open && dropdownElements">
    <div class="position-absolute dropdown-container">
      <div
        *ngFor="let element of dropdownElements"
        class="fs-14"
        (click)="updateFontWeight(element)"
      >
        {{ element }}
      </div>
    </div>
  </div> -->
</div>
